/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-22 18:32:57
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-11-25 16:00:04
 * @FilePath: /unifyxp-v2-store-portal/src/components/BulkEditor/BulkEditor.tsx
 */
import { DownOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
// import { Menu } from 'antd';
import { replaceI18nVariables } from '@/src/tools/tools';
import { DropDown, Menu, MenuItem } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';
export enum MenuItemType {
  Primary = 'Primary',
  Error = 'Error',
}
const BulkEditor = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    id = '',
    bulkEditItemClassName = '',
    buttonMenu,
    selectedRowKeys = [],
    total = 0,
    //  dataSource,
    selectAll,
    hideSelectAll,
    selectedAll = false,
    bulkEditText,
    hideSelectDescription,
  } = props;
  const selectedLength = React.useMemo(
    () => (selectedRowKeys || []).length || 0,
    [selectedRowKeys],
  );

  const allSelect = useMemo(() => {
    const allSelected = selectedAll ? total : selectedRowKeys.length || 0;
    return allSelected > 0 ? (
      <span className={css.tableIntroduce}>
        {replaceI18nVariables(
          getI18n(`general.bulkEditor.all_select`),
          allSelected,
        )}
      </span>
    ) : (
      ' '
    );
  }, [total, selectedRowKeys, selectedAll]);
  //, [selectedRowKeys, dataSource, selectedAll]
  const allItems = useMemo(() => {
    return (
      !(selectedAll || selectedLength === total) && (
        <span className={css.selectAll} onClick={selectAll}>
          {replaceI18nVariables(
            getI18n(`general.bulkEditor.select_all`),
            total,
          )}
        </span>
      )
    );
  }, [selectedAll, selectedLength, total]);

  const bulkEdit = React.useMemo(
    () => (
      <Menu className={bulkEditItemClassName}>
        {(buttonMenu || []).map((item) => (
          <MenuItem
            key={item.key}
            disabled={item.disabled}
            className={
              item.type == MenuItemType.Error
                ? css.bulkEditItemError
                : item.type == MenuItemType.Primary
                ? css.bulkEditItemPrimary
                : ''
            }
            onClick={() => {
              if (item.function) item.function(selectedRowKeys, selectedAll);
            }}>
            {item.value}
          </MenuItem>
        ))}
      </Menu>
    ),
    [buttonMenu, selectedRowKeys],
  );
  return (
    <div className={css.tableHeader}>
      <div className={css.dropMenu}>
        <div className={css.dropButton}>
          <div className={css.disableButton}>
            {replaceI18nVariables(
              getI18n(`general.bulkEditor.selected`),
              selectedAll ? total : selectedLength,
            )}
          </div>

          <DropDown
            disabled={
              (selectedRowKeys || []).length < 1 ||
              (buttonMenu || []).every((b) => b.disabled)
            }
            overlay={bulkEdit}
            placement='bottomRight'
            trigger={['click']}
            getPopupContainer={() =>
              id ? document.getElementById(id) : document.body
            }>
            <a
              id={id ? id : ''}
              className={css.BulkEdit}
              onClick={(e) => e.preventDefault()}>
              {bulkEditText || `${getI18n(`general.bulkEditor.title`)} `}
              <DownOutlined />
            </a>
          </DropDown>
        </div>
        {!hideSelectDescription && allSelect} {!hideSelectAll && allItems}
      </div>
    </div>
  );
};
export default BulkEditor;
